var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1554FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8913 10.3619L16.0733 14.1799C15.876 14.3769 15.7415 14.6279 15.6867 14.9012L15.334 16.6666L17.0993 16.3132C17.3727 16.2586 17.6233 16.1246 17.8207 15.9272L21.6387 12.1092C21.7534 11.9945 21.8444 11.8583 21.9065 11.7084C21.9686 11.5585 22.0005 11.3978 22.0005 11.2356C22.0005 11.0733 21.9686 10.9126 21.9065 10.7627C21.8444 10.6128 21.7534 10.4766 21.6387 10.3619C21.5239 10.2472 21.3877 10.1561 21.2378 10.0941C21.0879 10.032 20.9272 10 20.765 10C20.6027 10 20.4421 10.032 20.2922 10.0941C20.1423 10.1561 20.006 10.2472 19.8913 10.3619Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 18.0007V20.0007C20.667 20.3543 20.5265 20.6934 20.2765 20.9435C20.0264 21.1935 19.6873 21.334 19.3337 21.334H12.0003C11.6467 21.334 11.3076 21.1935 11.0575 20.9435C10.8075 20.6934 10.667 20.3543 10.667 20.0007V12.6673C10.667 12.3137 10.8075 11.9746 11.0575 11.7245C11.3076 11.4745 11.6467 11.334 12.0003 11.334H14.0003",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircleBlue);
export default __webpack_public_path__ + "static/media/editCircleBlue.23d2094e5cfc18bd4b9c36f481031689.svg";
export { ForwardRef as ReactComponent };